module.exports = __webpack_public_path__ + "poster.png?660aa0c1d6f862452431abd8bf22c4c3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poster.png
// module id = 183
// module chunks = 0